import { Tooltip } from 'antd';
import React from 'react';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/undraw-to-do-list.svg';

export const BehavioursPracticeStep = withTranslation('cbt')(({ t }: WithTranslation) => {
    const descriptions: string[] = t('week-6.behaviours-practice.descriptions', {
        returnObjects: true,
    });

    const activities: string[] = t('week-6.behaviours-practice.plannedActivities.activities', {
        returnObjects: true,
    });

    return (
        <S.ContentRow>
            <S.ContentColumn md={14}>
                <S.StepHeading small>{t('week-6.behaviours-practice.heading')}</S.StepHeading>
                <S.StepHeading>{t('week-6.behaviours-practice.title')}</S.StepHeading>
                {descriptions.map(description => (
                    <S.StepDescription small key={description}>
                        {description}
                    </S.StepDescription>
                ))}
                <S.PlannedActivitiesHolder>
                    <S.PlannedActivitiesHeading>
                        {t('week-6.behaviours-practice.plannedActivities.heading')}
                    </S.PlannedActivitiesHeading>
                    {activities.map((activity: string) => (
                        <S.PlannedActivity smallPadding key={activity}>
                            <S.ActivityContent isNested>{activity}</S.ActivityContent>
                        </S.PlannedActivity>
                    ))}
                </S.PlannedActivitiesHolder>
                <S.StepDescription small>
                    <Trans i18nKey="week-6.behaviours-practice.track-emotion">
                        You can track lifecycle of emotion (including behavoiurs and consequences)
                        <Tooltip placement="top" title={'Comming soon'}>
                            <S.StyledWord> here</S.StyledWord>.
                        </Tooltip>
                    </Trans>
                </S.StepDescription>
            </S.ContentColumn>
            <S.ContentColumn md={10}>
                <S.StepIcon large iconUrl={stepIcon} />
            </S.ContentColumn>
        </S.ContentRow>
    );
});
